import { hc } from "hono/client";
import { useMemo } from "react";
import type { AppType } from "../../../../packages/functions/src/gems/api/public";
import type { App as PublicApp } from "../../../../packages/functions/src/api/public";

export const createClient = (endpoint: string) => {
  return hc<PublicApp>(endpoint, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createGemsClient = (endpoint: string) => {
  return hc<AppType>(endpoint, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const useClient = (endpoint: string) => {
  return useMemo(() => createClient(endpoint), [endpoint]);
};

export const useGemsClient = (endpoint: string) => {
  return useMemo(() => createGemsClient(endpoint), [endpoint]);
};
